/* global window */
'use strict';

module.exports = require('./ponyfill')(global || window || this);



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/redux/~/symbol-observable/index.js
// module id = hlMi
// module chunks = 1